import React, { useState } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';

const reportReasons = {
  card: [
    'Inappropriate Card Content',
    'Inappropriate Card Art',
    'Inappropriate User Name',
    'Spam / Unrelated Content',
  ],
  comment: [
    'Harassment',
    'Spam',
    'Inappropriate User Name',
    'Inappropriate Profile Picture',
  ],
};

const ReportModal = ({ show, onHide, onSubmit, reportType = 'card', reportItemId }) => {
  const [reportReason, setReportReason] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleReportReasonChange = (e) => {
    setReportReason(e.target.value);
    if (e.target.value !== 'custom') {
      setCustomReason('');
    }
  };

  const handleCustomReasonChange = (e) => {
    setCustomReason(e.target.value);
  };

  const handleReportSubmit = async () => {
    const finalReason = reportReason === 'custom' ? customReason : reportReason;
    
    if (onSubmit) {
      onSubmit(reportType, reportItemId, finalReason);
    } else {
      try {
        setIsSubmitting(true);
        const response = await axios.post('/api/report.php', {
          id: reportItemId,
          reportedType: reportType,
          reason: finalReason,
        });

        if (response.data.success) {
          alert('Report submitted successfully');
          onHide();
          setReportReason('');
          setCustomReason('');
        } else {
          alert('Failed to submit report');
        }
      } catch (error) {
        console.error('Error submitting report:', error);
        alert('An error occurred while submitting the report');
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  // Ensure we have a valid reportType
  const currentReportType = reportReasons.hasOwnProperty(reportType) ? reportType : 'card';

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Report {currentReportType === 'card' ? 'Card' : 'Comment'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="reportReason">
            <Form.Label>Thank you for looking out for the community!</Form.Label>
            <Form.Control
              className="form-select mb-3"
              as="select"
              value={reportReason}
              onChange={handleReportReasonChange}
            >
              <option value="">Select a reason...</option>
              {reportReasons[currentReportType].map((reason, index) => (
                <option key={index} value={reason}>{reason}</option>
              ))}
              <option value="custom">Other (please specify)</option>
            </Form.Control>
          </Form.Group>
          
          {reportReason === 'custom' && (
            <Form.Group controlId="customReason">
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Please enter your reason here..."
                value={customReason}
                onChange={handleCustomReasonChange}
              />
            </Form.Group>
          )}
          
          <div className="d-flex justify-content-end mt-3">
            <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>Cancel</Button>
            <Button 
              variant="danger" 
              className="ms-2" 
              onClick={handleReportSubmit}
              disabled={!reportReason || (reportReason === 'custom' && !customReason) || isSubmitting}
            >
              {isSubmitting ? 'Submitting...' : 'Report'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ReportModal;